import { TableContainer } from '@mui/material';

/** Outer scroll region: border and shadow live here, not on the table. */
export const scrollableTableContainerSx = {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    boxShadow: 'var(--shadow-light)',
    backgroundColor: 'var(--background-color)',
};

/** Inner table: avoids double chrome from global .MuiTable-root rules in Case.css. */
export function scrollableTableSx(minWidth) {
    return {
        minWidth,
        backgroundColor: 'var(--background-color)',
        overflow: 'visible',
        border: 'none',
        boxShadow: 'none',
        borderRadius: 0,
    };
}

export const MEDICAL_EXPENSES_TABLE_MIN_WIDTH = 1200;
export const MEDICAL_CHRONOLOGY_CONSOLIDATED_TABLE_MIN_WIDTH = 1020;
export const MEDICAL_CHRONOLOGY_ALL_RECORDS_TABLE_MIN_WIDTH = 1320;

export default function ScrollableTableContainer({ children, sx, ...props }) {
    return (
        <TableContainer sx={{ ...scrollableTableContainerSx, ...sx }} {...props}>
            {children}
        </TableContainer>
    );
}
